module.exports = __webpack_public_path__ + "assets/img/index-intro-03@2x.858ef06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/index-intro-03@2x.png
// module id = 905
// module chunks = 1